import type { WithStyles } from '@material-ui/core';
import { CircularProgress, withStyles } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import type VideoStore from 'tm3-core/controls/video/store';
import JoinOptions from './join-options';
import styles from './styles';
import VideoIdPrompt from './video-id-prompt';

interface IProps extends WithStyles<typeof styles> {
  videoId: string;
  videoStore?: VideoStore;
}

@inject('videoStore')
@observer
class VideoAppointment extends Component<IProps> {
  componentDidMount() {
    if (this.props.videoId) {
      this.props.videoStore.startVideo(this.props.videoId, true, false);
    } else {
      this.props.videoStore.enableLocalPreview();
    }
  }
  render() {
    const {
      classes: { containerCentre, localPreview, flipContent, message, grid, cameraWrapper }
    } = this.props;
    const {
      videoStore: { hasPreview, loading, roomCreated, videoCode, callEnded },
      videoId
    } = this.props;

    return (
      <div className={containerCentre}>
        <h1>
          {roomCreated && !callEnded
            ? 'Your video appointment is ready to begin.'
            : 'Video consultation information'}
        </h1>
        <div className={grid}>
          <div className={cameraWrapper}>
            <h4>Your camera preview</h4>
            <div className={localPreview}>
              {!hasPreview && (
                <span className={message}>Please make sure your webcam is enabled.</span>
              )}
              <div id="local-media" className={flipContent} />
            </div>
          </div>
          <div>
            <br />
            <br />
            <br />

            {loading && !callEnded && <CircularProgress />}
            {videoId || videoCode ? <JoinOptions videoId={videoId} /> : <VideoIdPrompt />}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(VideoAppointment);
